import type { FC } from 'react';
import { QText } from '../../../QAtoms';
import { CellRenderProps } from '../CellRenderProps';

export const TextCell: FC<CellRenderProps<unknown>> = ({ value }) => (
  <QText>{value}</QText>
);
